import * as React from 'react';
import {Outlet} from "react-router-dom";
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';
import Box from '@mui/joy/Box';
import Sidebar from './Sidebar';
import Header from './Header';
import {Experimental_CssVarsProvider, THEME_ID, experimental_extendTheme} from '@mui/material/styles';

const materialTheme =experimental_extendTheme();

export function Home() {
    return (
        <Experimental_CssVarsProvider theme={{[THEME_ID]: materialTheme}}>
            <JoyCssVarsProvider disableTransitionOnChange>
                <CssBaseline/>
                <Box sx={{display: 'flex', minHeight: '100dvh'}}>
                    <Header/>
                    <Sidebar/>
                    <Box
                        component="main"
                        className="MainContent"
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            minWidth: 0,
                            minHeight: '100dvh',
                            overflow: 'auto',
                            gap: 1,
                        }}
                    >
                        <Outlet/>
                    </Box>
                </Box>
            </JoyCssVarsProvider>
        </Experimental_CssVarsProvider>
    );
}
